import { Box, Container, Grid, Paper, Typography } from '@mui/material';
import { Monitor, FlaskConical, Laptop, BookOpen, Activity, Bus, Lock, Building } from 'lucide-react';

const ICON_MAP = {
  Monitor,
  FlaskConical,
  Laptop,
  BookOpen,
  Activity,
  Bus,
  Lock,
};

export function Facilities({ data }) {
  const primaryColor = data.primary_color || '#1e3a8a';
  const facilitiesList = Array.isArray(data.facilities) ? data.facilities : [];

  if (facilitiesList.length === 0) return null;

  return (
    <Box id="facilities" sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#f8fafc' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', maxWidth: 640, mx: 'auto', mb: 7 }}>
          <Box sx={{ display: 'inline-block', px: 2, py: 0.5, borderRadius: 4, backgroundColor: `${primaryColor}15`, color: primaryColor, mb: 1.5 }}>
            <Typography variant="caption" fontWeight={700} letterSpacing="0.05em">
              WORLD-CLASS AMENITIES
            </Typography>
          </Box>
          <Typography variant="h2" fontWeight={800} color="#0f172a" sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, mb: 1 }}>
            Campus Infrastructure & Facilities
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Modern infrastructure built to provide a safe, vibrant, and engaging learning atmosphere.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {facilitiesList.map((item, index) => {
            const isString = typeof item === 'string';
            const name = isString ? item : item.name;
            const description = isString ? '' : item.description;
            const IconComponent = (!isString && item.icon && ICON_MAP[item.icon]) ? ICON_MAP[item.icon] : Building;

            return (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3.5,
                    height: '100%',
                    borderRadius: 4,
                    backgroundColor: '#ffffff',
                    border: '1px solid #e2e8f0',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-6px)',
                      boxShadow: '0 20px 35px rgba(0, 0, 0, 0.08)',
                      borderColor: primaryColor,
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: 3,
                      backgroundColor: `${primaryColor}10`,
                      color: primaryColor,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 2.5,
                    }}
                  >
                    <IconComponent size={26} />
                  </Box>
                  <Typography variant="h6" fontWeight={800} color="#0f172a" sx={{ mb: 1 }}>
                    {name}
                  </Typography>
                  {description && (
                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                      {description}
                    </Typography>
                  )}
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
}

export default Facilities;
